import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  height: 100%;
`;

export const Title = styled.h1`
  color: #181818;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const ContentScroller = styled.div.attrs({
  "data-testid": "content-scroll",
} as Record<string, string>)`
  min-height: 0;
  flex: 1 1 auto;
  overflow: auto;
  padding-right: 16px;
`;
